module.exports = __webpack_public_path__ + "img/1204.131da640.jpg";